var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep2Outline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5998 13.9V15H8.43984V14.13L11.2198 11.49C11.5332 11.19 11.7432 10.93 11.8498 10.71C11.9632 10.4833 12.0198 10.26 12.0198 10.04C12.0198 9.71333 11.9098 9.46333 11.6898 9.29C11.4698 9.11667 11.1465 9.03 10.7198 9.03C10.0065 9.03 9.45984 9.27333 9.07984 9.76L8.16984 9.06C8.44318 8.69333 8.80984 8.41 9.26984 8.21C9.73651 8.00333 10.2565 7.9 10.8298 7.9C11.5898 7.9 12.1965 8.08 12.6498 8.44C13.1032 8.8 13.3298 9.29 13.3298 9.91C13.3298 10.29 13.2498 10.6467 13.0898 10.98C12.9298 11.3133 12.6232 11.6933 12.1698 12.12L10.2998 13.9H13.5998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2Outline);
export default __webpack_public_path__ + "static/media/step-2-outline.422257774735d488999eb14fcacd168e.svg";
export { ForwardRef as ReactComponent };